<button
  type="button"
  mat-icon-button
  class="agent-launcher-button"
  [class.agent-launcher-button--active]="isOpen()"
  [attr.aria-label]="'agent.open' | translate"
  [attr.aria-pressed]="isOpen()"
  [matTooltip]="'agent.open' | translate"
  (click)="toggle()"
  data-test="agent-panel-toggle">
  <span class="agent-launcher-button__mark" aria-hidden="true"></span>
</button>
